<template>
    <!--错题集-->
  <div id="wrongbank">
    <person-head :title="title"></person-head>
    <h1 style="display: none">小学综合素质</h1>
    <div class="wrongnum">
      <h6>{{wrongNumber}}</h6>
      <p>错题数</p>
    </div>
    <h5>章节练习</h5>
    <div class="cc" v-for="(item, index) in wrongData" :key="index" :title="item.exam_id">
      <h4 class="active" @click="showAndHide">{{item.name}} <br><span>错题：{{item.number}}</span></h4>
      <wrong-bank-list :examId="item.exam_id" @listenDel="showPopup"></wrong-bank-list>
    </div>
    <div class="popup" v-show="popupShow">
      <h3>确定要删除错题记录吗？</h3>
      <div class="sub">
        <a @click="delQuestion">确认</a>
        <a @click="hidePopup">取消</a>
      </div>
      <a class="close" @click="hidePopup">&times;</a>
    </div>
    <div class="bg" v-show="popupShow" @click="hidePopup"></div>
  </div>
</template>

<script>
import WrongBankList from './WrongBankList'
import personHead from '../share/header/personHead'
export default {
  name: 'WrongBank',
  data () {
    return {
      page: 1,
      limit: 100,
      wrongData: {},
      popupShow: false,
      wrongNumber: 0,
      mistakesId: 0,
      title: '错题集'
    }
  },
  components: {
    WrongBankList,
    personHead
  },
  methods: {
    getWrong () {
      let data = {
        page: this.page,
        limit: this.limit
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_item_wrong_test_paper',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.wrongData = res.data.data
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.$router.push({name: 'PwdLogin', query: {backto: 'WrongBank'}})
          } else if (res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.$router.push({name: 'PwdLogin', query: {backto: 'WrongBank'}})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    showPopup (id) {
      this.mistakesId = id
      this.popupShow = true
    },
    hidePopup () {
      this.popupShow = false
    },
    getWrongNumber () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_item_wrong_count',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.wrongNumber = res.data.data.number
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.$router.push({name: 'PwdLogin', query: {backto: 'WrongBank'}})
          } else if (res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.$router.push({name: 'PwdLogin', query: {backto: 'WrongBank'}})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    removeWrong () {
      let data = {
        mistakes_id: this.mistakesId
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_item_wrong_question_del',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.$router.go(0) // 删除成功后刷新当前页
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.$router.push({name: 'PwdLogin', query: {backto: 'WrongBank'}})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    delQuestion () {
      if (this.mistakesId) {
        this.removeWrong()
      }
      this.hidePopup()
    },
    showAndHide (event) {
      let _el = event.currentTarget
      if (_el.getAttribute('class') === 'active') {
        _el.setAttribute('class', '')
      } else {
        _el.setAttribute('class', 'active')
      }
    }
  },
  mounted () {
    this.getWrong()
    this.getWrongNumber()
  }
}
</script>

<style scoped lang="stylus">
  #wrongbank
    h1
      position: relative
      width: 6.54rem
      height: 1.2rem
      line-height: 1.2rem
      background-color: #FAFAFA
      margin: 0 auto
      font-size: .36rem
      color: #050505
      text-align: center
      -webkit-border-radius: .2rem
      -moz-border-radius: .2rem
      border-radius: .2rem
      &::after
        content: ""
        position: absolute
        top: .5rem
        right: .4rem
        display: block
        width: 0
        height: 0
        border-top: .2rem solid #464646
        border-left: .13rem solid transparent
        border-right: .13rem solid transparent
    .wrongnum
      width: 7.5rem
      height: 4.08rem
      background: url(../../assets/img/wrongbank_bg_wrong.png) no-repeat left center
      -webkit-background-size: 7.04rem 4.08rem
      background-size: 7.04rem 4.08rem
      overflow: hidden
      margin-top: .52rem
      h6
        margin-top: 1.08rem
        font-size: .64rem
        color: #fff
        text-align: center
      p
        font-size: .32rem
        color: #fff
        text-align: center
    h5
      padding: .5rem  .2rem .32rem
      font-size: .48rem
      color: #050505
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
    .cc
      padding: .2rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      h4
        position: relative
        z-index: 10
        width: 7.1rem
        height: 1.2rem
        border: .02rem solid #CFD1D4
        background-color: #fff
        padding: .22rem .74rem
        font-size: .32rem
        color: #050505
        font-weight: 600
        -webkit-border-radius: .16rem
        -moz-border-radius: .16rem
        border-radius: .16rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        span
          font-size: .22rem
          color: #9DA4B3
        &::before
          content: "-"
          position: absolute
          top: .44rem
          left: .22rem
          display: block
          width: .3rem
          height: .3rem
          line-height: 0.25rem
          border: .02rem solid #D8D8D8
          font-size: 0.5rem
          color: #F23D27
          font-weight: 100
          text-align: center
          -webkit-border-radius: 50%
          -moz-border-radius: 50%
          border-radius: 50%
        &.active::before
          content: "+"
          line-height: .3265rem
          font-size: .32rem
      >>> h4 + ul
        position: relative
        top: -.1rem
        z-index: 5
        display: none
        width: 7.1rem
        background-color: #FAFAFA
        overflow: hidden
        -webkit-border-radius: .16rem
        -moz-border-radius: .16rem
        border-radius: .16rem
        li
          display: flex
          justify-content: space-between
          align-items: flex-end
          width: 7.1rem
          height: 1.1rem
          border-bottom: .02rem solid #F0F0F1
          padding: .2rem .2rem .2rem .72rem
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          &:last-child
            border: none
          b
            display: block
            width: 3.5rem
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            font-size: .3rem
            color: #333
          i
            display: block
            font-size: .22rem
            color: #9DA4B3
          a.redo
            display: inline-block
            width: 1.16rem
            height: .44rem
            line-height: .4rem
            border: .02rem solid #FF7052
            font-size: .24rem
            color: #FF7052
            text-align: center
            -webkit-box-sizing: border-box
            -moz-box-sizing: border-box
            box-sizing: border-box
            -webkit-border-radius: .22rem
            -moz-border-radius: .22rem
            border-radius: .22rem
            img
              width: .2rem
              height: .24rem
          a.check
            display: inline-block
            width: 1.16rem
            height: .44rem
            line-height: .4rem
            border: .02rem solid #FF7052
            background-color: #FF7052
            margin-left: .16rem
            font-size: .24rem
            color: #fff
            text-align: center
            -webkit-box-sizing: border-box
            -moz-box-sizing: border-box
            box-sizing: border-box
            -webkit-border-radius: .22rem
            -moz-border-radius: .22rem
            border-radius: .22rem
            img
              width: .22rem
              height: .22rem
      >>> h4.active + ul
        display: block
    .cc0
      display: none
      img
        display: block
        width: 3.4rem
        height: 2.63rem
        margin: 0 auto
      h4
        margin: .4rem 0 .05rem
        font-size: .32rem
        color: #050505
        text-align: center
      p
        margin: 0 0 .6rem
        font-size: .24rem
        color: #9DA4B3
        text-align: center
    .popup
      position: fixed
      top: 50%
      left: 50%
      z-index: 100
      width: 5.2rem
      height: 2.4rem
      background-color: #fff
      -webkit-border-radius: .16rem
      -moz-border-radius: .16rem
      border-radius: .16rem
      -webkit-transform: translate(-50%, -50%)
      -moz-transform: translate(-50%, -50%)
      -ms-transform: translate(-50%, -50%)
      -o-transform: translate(-50%, -50%)
      transform: translate(-50%, -50%)
      h3
        margin: .48rem 0 .32rem
        font-size: .32rem
        color: #333
        text-align: center
      .sub
        display: flex
        justify-content: space-between
        width: 3.76rem
        height: .68rem
        margin: .42rem auto
        a
          display: inline-block
          width: 1.64rem
          height: .68rem
          line-height: .64rem
          border: .02rem solid #FF7052
          font-size: .36rem
          color: #FF7052
          text-align: center
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          -webkit-border-radius: .4rem
          -moz-border-radius: .4rem
          border-radius: .4rem
          &:first-child
            background-color: #FF7052
            color: #fff
      a.close
        position: absolute
        top: .2rem
        right: .2rem
        display: block
        width: .3rem
        height: .3rem
        line-height: .24rem
        font-size: .4rem
        text-align: center
    .bg
      position: fixed
      top: 0
      left: 0
      z-index: 50
      width: 100%
      height: 100%
      background-color: rgba(0, 0, 0, .4)
</style>



// WEBPACK FOOTER //
// src/components/exam/WrongBank.vue